import React from 'react';
import { InstagramIcon, FacebookIcon, MessageCircleIcon } from 'lucide-react';
export const Footer: React.FC = () => {
  return <footer className="bg-white border-t border-gray-200 pt-16 pb-8" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8 space-y-6 md:space-y-0" data-id="element-12">
          <div className="flex flex-col items-center md:items-start" data-id="element-13">
            <img src="https://cdn.magicpatterns.com/uploads/vNGUiNwgY6GeirQwf8eShH/Domus_nuevo_logo_rojo_(1).png" alt="REMAX Domus Logo" className="h-12 w-auto mb-4" data-id="element-14" />
            <p className="text-gray-600 font-medium text-center md:text-left" data-id="element-15">
              REMAX Domus | Caracas, Venezuela
              <br data-id="element-16" />
              <span className="text-remax-blue font-semibold" data-id="element-17">
                Potenciado por Demand OS
              </span>
            </p>
          </div>

          <div className="flex space-x-6" data-id="element-18">
            <a href="#" className="text-gray-400 hover:text-remax-red transition-colors" aria-label="Instagram" data-id="element-19">
              <InstagramIcon size={24} data-id="element-20" />
            </a>
            <a href="#" className="text-gray-400 hover:text-remax-blue transition-colors" aria-label="Facebook" data-id="element-21">
              <FacebookIcon size={24} data-id="element-22" />
            </a>
            <a href="#" className="text-gray-400 hover:text-green-500 transition-colors" aria-label="WhatsApp" data-id="element-23">
              <MessageCircleIcon size={24} data-id="element-24" />
            </a>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-25">
          <p data-id="element-26">
            &copy; {new Date().getFullYear()} REMAX Domus. Todos los derechos
            reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-27">
            <a href="#" className="hover:text-remax-dark transition-colors" data-id="element-28">
              Privacidad
            </a>
            <a href="#" className="hover:text-remax-dark transition-colors" data-id="element-29">
              Términos
            </a>
            <a href="#contacto" className="hover:text-remax-dark transition-colors" data-id="element-30">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
};